module.exports = __webpack_public_path__ + "static/img/off-rock.b6a73ae.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/off-rock.gif
// module id = LvUj
// module chunks = 0